function formatSignificant(formatted: string, maxSignificantDigits = 1): string {
  const parts = formatted.split('.')
  const integerPart = parts[0]
  let fractionalPart = parts[1] ? `${parts[1].substring(0, maxSignificantDigits)}` : '0'
  if (fractionalPart === '0') fractionalPart = ''
  const balanceNumber = Number(integerPart)

  const result = `${integerPart}${fractionalPart ? `.${fractionalPart}` : ''}`

  return balanceNumber < 0 ? `-${result}` : result
}

export function formatBigNumber(n: bigint): string {
  const num = Number(n)
  if (num >= 1_000_000_000) {
    return `${formatSignificant(Number(num / 1_000_000_000).toFixed(1))}B`
  }
  if (num >= 1_000_000) {
    return `${Number(num / 1_000_000).toFixed(1)}M`
  }
  if (num >= 1_000) {
    return `${formatSignificant(Number(num / 1_000).toFixed(1))}K`
  }
  return num.toString()
}
